import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "header z-40 p-0 sm:p-4 md:p-4 lg:p-4 bg-white dark:bg-gray-800" }
const _hoisted_2 = {
  key: 0,
  class: "header-left"
}
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = { class: "w-11 dark:white-logo" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode()
const _hoisted_6 = /*#__PURE__*/_createElementVNode("small", { style: {"left":"-1em","position":"relative"} }, "nitome", -1)
const _hoisted_7 = {
  key: 1,
  class: "header-menu"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Dashboard")
const _hoisted_9 = {
  key: 2,
  class: "user-settings"
}
const _hoisted_10 = {
  key: 2,
  class: "btn-header"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Dashboard ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "user-profile",
  src: "{{userInfo.thumbnailUrl}}",
  alt: "profile"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoCmp = _resolveComponent("LogoCmp")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isSiteDown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "flex flex-nowrap flex-row justify-center items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LogoCmp),
                  _hoisted_5,
                  _hoisted_6
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isSiteDown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.role == 'subscriber')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["menu-item", { active: _ctx.pagepath.indexOf('home') != -1}])
              }, [
                _createVNode(_component_router_link, { to: "/home" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["menu-item", { active: _ctx.pagepath.indexOf('/lyrics/search') != -1}])
          }, [
            _createVNode(_component_router_link, { to: "/lyrics/search" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.discoverBtn), 1)
              ]),
              _: 1
            })
          ], 2),
          (_ctx.role == 'guest')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["menu-item", { active: _ctx.pagepath.indexOf('/about') != -1}])
              }, [
                _createVNode(_component_router_link, { to: "/about" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.aboutBtn), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isSiteDown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.role == 'guest')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn navbar-toggler link-medium btn-secondary",
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.login())),
                style: {"margin":"2px"}
              }, _toDisplayString(_ctx.signinBtn), 1))
            : _createCommentVNode("", true),
          (_ctx.role == 'guest')
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "btn navbar-toggler link-medium flex",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.join && _ctx.join(...args)))
              }, _toDisplayString(_ctx.joinBtn), 1))
            : _createCommentVNode("", true),
          (_ctx.role == 'subscriber' || _ctx.role == 'contributor')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_router_link, { to: "/my-account" }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}